import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ListAllNotifications } from './userNotification.repository';
import { ErrorDto } from '../../models/dtos/error.dto';
import { Errors } from '../errors';
import { UserNotification } from '../../models/response/notification';

type InitialState = {
  loading: boolean;
  data?: UserNotification[];
  error?: ErrorDto;
};
const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const listAllNotification = createAsyncThunk(
  'listAllNotifications',
  async (_, { dispatch }) => {
    return (await ListAllNotifications()).data;
  }
);

const listAllNotificationsSlice = createSlice({
  name: 'listAllNotifications',
  initialState,
  reducers: {
    listAllNotificationsReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(listAllNotification.pending, (state) => {
      state.loading = true;
      state.data = undefined;
      state.error = undefined;
    });
    builder.addCase(
      listAllNotification.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(listAllNotification.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default listAllNotificationsSlice.reducer;
